var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-weight-bold text-body-1 text-decoration-underline my-6 mt-8"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }